import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import { WIDGET_API } from 'utils/constants';

import { formRouteRequiredFields } from '../formatters/routingFormatter';
import type {
  Parameter,
  PayHubCashierContractsInitParamsResponse,
  PayHubCashierContractsViewDataResponse,
} from '../models';

export interface SendRouteResponse {
  parameters: PayHubCashierContractsInitParamsResponse[];
  view_data?: PayHubCashierContractsViewDataResponse[] | null;
}

export interface ProcessedSendRouteResponse {
  method_workflow_type?: string;
  parameters: Parameter[];
  view_data?: PayHubCashierContractsViewDataResponse[] | null;
}

export interface SendRouteRequest {
  payload: {
    paygroup_id?: number | null;
    amount?: number;
    currency: string;
    card_data?: {
      [p: string]: string | number | boolean | undefined;
    };
  };
  flowType: string;
}

export const routingAPI = createApi({
  reducerPath: 'routingAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      sendRoute: builder.mutation<ProcessedSendRouteResponse, SendRouteRequest>({
        query: ({ payload, flowType }) => ({
          url: `${flowType}/groups/${payload.paygroup_id}/route`,
          method: 'POST',
          body: {
            ...payload,
          },
        }),
        transformResponse: (response: SendRouteResponse): ProcessedSendRouteResponse => ({
          ...response,
          parameters: formRouteRequiredFields(response.parameters),
        }),
      }),
    };
  },
});

export const { useSendRouteMutation } = routingAPI;
export default routingAPI.reducer;
